import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import NotFound from "@/pages/not-found";
import Navbar from "@/components/layout/navbar";
import Footer from "@/components/layout/footer";
import Home from "@/pages/home";
import Services from "@/pages/services";
import About from "@/pages/about";
import Team from "@/pages/team";
import Contact from "@/pages/contact";
import "./lib/fonts";
import usePageTracking from '@/components/ui/analytics';

import ReactGA from "react-ga4";

function Router() {
    usePageTracking();
    return (
        <Switch>
            <Route path="/" component={Home} />
            <Route path="/services" component={Services} />
            <Route path="/about" component={About} />
            <Route path="/team" component={Team} />
            <Route path="/contact" component={Contact} />
            <Route component={Home} />
        </Switch>
    );
}

function App() {

    ReactGA.initialize("G-FSLMC8SGE9"); // Replace with your GA4 Measurement ID

    return (
        <QueryClientProvider client={queryClient}>
            <div className="min-h-screen flex flex-col">
                <Navbar />
                <main className="flex-grow pt-20">
                    <Router />
                </main>
                <Footer />
            </div>
            <Toaster />
        </QueryClientProvider>
    );
}

export default App;
